import { useEffect } from "react";
import { withTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useUserCollectionAddress, useReloadUserAddresses, useLocalCarrierName, useHasMultipleCollectionMethods } from "@hooks/use-addresses";
import carriers from "@utils/constants/carriers";
import Link from "@components/core/Link";

function ReturnModeValidation({ t }) {
  const router = useRouter();

  const collectionAddress = useUserCollectionAddress();
  const reloadUserAddresses = useReloadUserAddresses();

  const carrierName = collectionAddress?.carrier_name || carriers.colissimo;
  const localCarrierName = useLocalCarrierName(carrierName, collectionAddress?.country);
  const hasMultipleCollectionMethods = useHasMultipleCollectionMethods();

  useEffect(() => {
    if (!collectionAddress) reloadUserAddresses();
  }, []);

  if (!collectionAddress) {
    return null;
  }

  return (
    <div className="d-flex flex-column bg-white p-3 gap-2">
      <div className="d-flex justify-content-between align-items-center">
        <p className="font-weight-bold font-size-sm text-uppercase mb-0">
          {t("common:drawer.modal_rtc.validate.addresses.return_mode")}
        </p>

        {hasMultipleCollectionMethods && (
          <Link
            className="link-primary no-underline"
            href={{
              pathname: "/profile/addresses/collection",
              query: {
                redirect: router.asPath,
                origin: "closetDrawer",
              },
            }}
          >
            {t("common:drawer.modal_rtc.validate.change")}
          </Link>
        )}
      </div>

      <p className="mb-0">
        {t(`common:drawer.modal_rtc.validate.addresses.carrier.${localCarrierName}`)}
      </p>
    </div>
  );
}

export default withTranslation("common")(ReturnModeValidation);
